import React from "react";
import { Box, IconButton, Popover } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import usePopover from "components/hooks/usePopover";
import LocationAddress from "../details/LocationAddressDetails";
import { LocationAddressFragment } from "__generated__/view/locations/graphql/location.fragments.generated";

const LocationAddressPopover = ({ address }: { address: LocationAddressFragment | null }) => {

	const { popoverProps, onPopoverOpen } = usePopover({
		trigger: "click",
	});

	if (address) {
		return (
			<React.Fragment>
				<span style={{ alignItems: "center", display: "flex" }}>
					{address.street || address.town || "-"}

					<IconButton onClick={(event) => onPopoverOpen(event)} size="small">
						<InfoOutlinedIcon fontSize="small" />
					</IconButton>
				</span>

				<Popover {...popoverProps}>
					<Box p={2} sx={{ width: 300 }}>
						<LocationAddress address={address} />
					</Box>
				</Popover>
			</React.Fragment>
		);
	} else {
		return <React.Fragment />;
	}
};

export default LocationAddressPopover;
